import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Card, CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import printCardStackAction from "cc-frontend/lib/actions/app-state/PRINT_CARD_STACK"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { formatCourseTime } from "cc-frontend/utils/course/times"
import { filter, includes, sortBy } from "lodash-es"

interface Signature {
  Args: {
    lesson: CardStack
    showStandardDescriptions: boolean
    showComments: boolean
    isFilteringCards: boolean
    visibleCards: Array<Card>
    hideCourseTitle: boolean
    hideLessonTitle: boolean
    course: Course
    courseDate: CourseDateCombined
    perspective: "day" | "week" | "month" | "timeline" | "standards_tracker"
  }
}

export default class PrintLessonComponent extends Component<Signature> {
  @service declare dispatcher: Dispatcher

  @computed("args.lesson.attributes.cards")
  get cards() {
    if (!this.args.lesson || !this.args.lesson.attributes.cards) return []

    let cards = sortBy(
      this.args.lesson.attributes.cards.filter((card) => card !== null && card !== undefined),
      (card) => card.attributes.position
    )

    // let visibleCards = get(this, "visibleCards")
    if (this.args.isFilteringCards) {
      return filter(cards, (card) => {
        // @ts-expect-error
        return includes(this.args.visibleCards, card.attributes.title)
      })
    } else {
      return cards
    }
  }

  // PRINT CARD STACK

  constructor(owner, args) {
    super(owner, args)
    if (this.args.lesson) {
      // if lesson is a template, no need to record that its being printed
      if (this.args.lesson.meta.isNewLesson === true) return
      this.dispatcher.dispatchPreparedAction(
        printCardStackAction({
          cardStackId: this.args.lesson.id,
          perspective: this.args.perspective,
        })
      )
    }
  }

  // TIMES

  @computed("args.courseDate.timeDefault")
  get hasTime() {
    return this.args.courseDate !== undefined && this.args.courseDate.timeDefault !== null
  }

  @computed("args.courseDate.timeCustom", "args.courseDate.timeDefault")
  get timeFormatted() {
    if (this.args.courseDate === undefined) return ""
    const time = this.args.courseDate.timeCustom ?? this.args.courseDate.timeDefault
    return formatCourseTime(time)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Print::PrintLesson": typeof PrintLessonComponent
  }
}
